import { VFilterBar, type VFilterBarOption } from '@vrzl/ui';

import type { CriterionFilter } from '../utils/filterCriteria';

const OPTIONS: ReadonlyArray<VFilterBarOption<CriterionFilter>> = [
  { value: 'all', label: 'Alles' },
  { value: 'present', label: 'Aanwezig' },
  { value: 'missing', label: 'Niet aanwezig' },
  { value: 'inconsistent', label: 'Inconsistent' },
];

interface InformationFilterProps {
  value: CriterionFilter;
  counts: Record<CriterionFilter, number>;
  onChange: (value: CriterionFilter) => void;
}

/**
 * Client-side segmented filter for the information list. Purely visual —
 * emits the selected mode via `onChange`; never touches the underlying data.
 */
export function InformationFilter({ value, counts, onChange }: InformationFilterProps) {
  return (
    <VFilterBar
      options={OPTIONS}
      value={value}
      counts={counts}
      onChange={onChange}
      ariaLabel="Filter criteria op aanwezigheid"
    />
  );
}
